import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { captureSlowOperation } from "../../sentry";

const rawIssueDetectionBaseQuery = fetchBaseQuery({
  baseUrl:
    process.env.REACT_APP_ISSUE_DETECTION_BASE_URL ||
    "https://issuedetection.zenyt.ai/",
  credentials: "omit", // Changed from "include" to "omit" to avoid CORS credentials issue
  prepareHeaders: (headers, { endpoint, getState }) => {
    if (!endpoint.includes("uploadImage")) {
      headers.set("Content-Type", "application/json");
    }

    // Remove Authorization header for now to avoid CORS issues
    // const token = getState().auth.token;
    // if (token) {
    //   headers.set("Authorization", `Bearer ${token}`);
    // }

    return headers;
  },
});

const issueDetectionBaseQuery = async (args, api, extraOptions) => {
  const start = Date.now();
  const result = await rawIssueDetectionBaseQuery(args, api, extraOptions);
  const durationMs = Date.now() - start;
  const thresholdMs = Number(process.env.REACT_APP_SENTRY_SLOW_API_THRESHOLD_MS || "3000");
  if (durationMs >= thresholdMs) {
    const url = typeof args === "string" ? args : args?.url || "unknown";
    const method = typeof args === "string" ? "GET" : args?.method || "GET";
    captureSlowOperation("console_frontend_api_call", durationMs, thresholdMs, {
      api: "issue-detection",
      endpoint: api.endpoint,
      url,
      method,
      status: result?.error?.status || "ok",
    });
  }
  return result;
};

export const issueDetectionApiSlice = createApi({
  reducerPath: "issueDetectionApi",
  baseQuery: issueDetectionBaseQuery,
  tagTypes: [
    "IssueDetection",
    "ScanTemplates",
    "WebsiteSpecificScanTemplates",
    "ScanTemplateSteps",
    "ScanTemplateCount",
  ],
  endpoints: () => ({}),
});
